// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"115":"e580b025","148":"5bd77abb","230":"8c589a70","453":"fdeaf49a","825":"1d76e078","874":"a295751f"}[chunkId] + ".chunk.js";
};